import React from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ChevronRightIcon, FileTextIcon, ShieldCheckIcon, SparklesIcon, WalletIcon } from 'lucide-react';
export type PanelId = 'consentements' | 'factures' | 'confidentialite' | 'atna';
interface Entry {
  id: PanelId | 'notifications';
  title: string;
  description: string;
  icon: typeof BellIcon;
  to?: string;
}
const entries: Entry[] = [{
  id: 'notifications',
  title: 'Notifications',
  description: 'Manage your communication preferences',
  icon: BellIcon,
  to: '/notifications/settings'
}, {
  id: 'consentements',
  title: 'Consents',
  description: 'Manage your consents and authorizations',
  icon: ShieldCheckIcon
}, {
  id: 'factures',
  title: 'My invoices',
  description: 'View your invoices and payments',
  icon: WalletIcon
}, {
  id: 'confidentialite',
  title: 'Privacy and transparency',
  description: 'Understand how your data and AI are used',
  icon: FileTextIcon
}, {
  id: 'atna',
  title: 'ATNA help',
  description: 'Ask a question or get help',
  icon: SparklesIcon
}];
interface AccountNavProps {
  onOpen: (panel: PanelId) => void;
}
export function AccountNav({
  onOpen
}: AccountNavProps) {
  return <section aria-labelledby="account-title" data-id="element-1708" data-mp="8rmftvev6is4">
      <h2 id="account-title" className="text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-1709" data-mp="8qkumy44wfwo">
        Manage my account
      </h2>
      <ul className="mt-3 space-y-2" data-id="element-1710" data-mp="3c7t9d93kezn6">
        {entries.map(entry => {
        const shared = 'group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo';
        const inner = <>
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-slate-100 text-ville-navy transition-colors duration-150 ease-ville group-hover:bg-ville-indigo-soft group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1711" data-mp="3h4tdvfkrnuc6">
                <entry.icon className="h-5 w-5" data-id="element-1712" data-mp="sfm1goxk4wk8" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-1713" data-mp="sd9luif9uyac">
                <span className="block text-[15px] font-bold text-ville-navy" data-id="element-1714" data-mp="xd5fpou999c6">{entry.title}</span>
                <span className="block text-sm leading-snug text-slate-500" data-id="element-1715" data-mp="125yja9dzmbmo">{entry.description}</span>
              </span>
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1716" data-mp="173gwwd2y9f10" />
            </>;
        return <li key={entry.id} data-id="element-1717" data-mp="eg47zw9bgv4j">
              {entry.to ? <Link to={entry.to} className={shared} data-id="element-1718" data-mp="eh5tyvrvf211">
                  {inner}
                </Link> : <button type="button" onClick={() => onOpen(entry.id as PanelId)} className={shared} data-id="element-1719" data-mp="jgs9jbv68ud0">
                  {inner}
                </button>}
            </li>;
      })}
      </ul>
    </section>;
}